"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={styleOverrides:{root:{height:"204px",width:"325px",padding:"0 10px",boxSizing:"border-box"}}};exports.MuiYearCalendar=e;
